import { FC, HTMLAttributes, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex, Modal, Typography } from 'antd';

import TelegramIcon from 'assets/images/icons/telegram.svg?react';
import { useOnboardingSlice } from 'features/Onboarding';
import { BOT_URL } from 'features/Telegram';
import { useGetAppConfigQuery, useUpdatePopupsMutation } from 'shared/api/commonApi';
import { EPopups } from 'shared/typings';

interface ITelegramModalProps extends HTMLAttributes<HTMLDivElement> {}

export const TelegramModal: FC<ITelegramModalProps> = ({ ...props }) => {
	const { t } = useTranslation();
	const { data: appConfig } = useGetAppConfigQuery();
	const { modalIsOpened } = useOnboardingSlice();
	const [isOpened, setIsOpened] = useState(false);
	const [updatePopup] = useUpdatePopupsMutation();

	useEffect(() => {
		setIsOpened(
			!!appConfig?.user?.not_shown_popups &&
				appConfig?.user?.not_shown_popups.includes(EPopups.TELEGRAM) &&
				!appConfig?.is_super_login &&
				!modalIsOpened,
		);
	}, [modalIsOpened, appConfig?.user?.not_shown_popups, appConfig?.is_super_login]);

	const onClose = () => {
		setIsOpened(false);
		updatePopup(EPopups.TELEGRAM);
	};

	return (
		<Modal {...props} width={520} centered open={isOpened} onCancel={onClose} footer={null} destroyOnClose>
			<Flex vertical gap={24} align="center" style={{ paddingTop: 32 }}>
				<TelegramIcon />

				<Typography.Title level={3} style={{ margin: 0 }}>
					{t('У нас есть Telegram-бот')}
				</Typography.Title>

				<Typography.Text type="secondary" style={{ fontSize: 16, textAlign: 'center' }}>
					{t(
						'Бот используется для получения уведомлений по движению на балансе, подключению на оффер и верификации площадок. Хотите подписаться на бот сейчас?',
					)}
				</Typography.Text>

				<Flex gap={12} justify="center" wrap>
					<Button onClick={onClose}>{t('Нет, подписаться позже')}</Button>
					<Button onClick={onClose} type="primary" href={BOT_URL} target="_blank">
						{t('Да, подписаться сейсас')}
					</Button>
				</Flex>
			</Flex>
		</Modal>
	);
};
